import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft } from 'lucide-react';

const Terms = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50" data-testid="terms-page">
      <div className="max-w-3xl mx-auto px-4 py-8">
        <Button variant="ghost" size="sm" onClick={() => navigate(-1)} className="mb-6" data-testid="terms-back-btn">
          <ArrowLeft className="h-4 w-4 mr-1" /> Back
        </Button>

        <h1 className="text-3xl font-bold text-gray-900 mb-2">Terms & Conditions</h1>
        <p className="text-sm text-gray-500 mb-8">Last updated: February 2026</p>

        <div className="prose prose-sm max-w-none space-y-6 text-gray-700">
          <section>
            <h2 className="text-xl font-semibold text-gray-900">1. Acceptance of Terms</h2>
            <p>
              By accessing or using Badminton Stats ("the App"), you agree to be bound by these Terms & Conditions. 
              If you do not agree, please do not use the App.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900">2. Account Registration</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>You must provide accurate information when creating an account.</li>
              <li>You are responsible for maintaining the security of your account credentials.</li>
              <li>One account per person. Duplicate accounts may be removed.</li>
              <li>You must be at least 13 years old to use this App.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900">3. User Content</h2>
            <p>You retain ownership of content you upload (videos, images, match data). By uploading, you grant us a license to:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>Store and display your content within the App.</li>
              <li>Process your videos through AI services for coaching analysis.</li>
              <li>Show your public posts in the Shorts feed to other users.</li>
            </ul>
            <p>You must not upload content that is illegal, harmful, or infringes on others' rights.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900">4. AI Coaching</h2>
            <p>
              The AI Coach feature provides automated feedback based on video analysis. This is for informational and training purposes only. 
              It is not a substitute for professional coaching. We do not guarantee the accuracy of AI-generated feedback.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900">5. Social Features</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>Be respectful in comments, messages, and interactions with other users.</li>
              <li>Do not harass, bully, or send unsolicited content to other users.</li>
              <li>We reserve the right to remove content or accounts that violate these terms.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900">6. Shorts & Videos</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>Short-form videos must be 60 seconds or less.</li>
              <li>Only upload videos you have the right to share.</li>
              <li>Videos must be related to badminton or sports activities.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900">7. Account Termination</h2>
            <p>
              You may delete your account at any time from your Profile page. We may suspend or terminate accounts 
              that violate these terms. Upon deletion, all your data will be permanently removed.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900">8. Limitation of Liability</h2>
            <p>
              The App is provided "as is" without warranties of any kind. We are not liable for any damages arising 
              from your use of the App, including data loss, inaccurate AI analysis, or service interruptions.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900">9. Changes to Terms</h2>
            <p>
              We may update these terms at any time. Continued use of the App after changes constitutes acceptance 
              of the new terms.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900">10. Contact</h2>
            <p>For questions about these terms, contact us at <strong>support@badmintonstats.app</strong>.</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Terms;
